import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'visitors'

export const useVisitorsReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Visitors',
    headerTooltipTitle: 'Visitors',
    headerTooltipDescription: 'Number of unique users visiting your site.',
  })
}
